//export const HOST = 'https://www.baum-bmwshop24.de';
export const HOST = 'https://react-1.baum-bmwshop24.de';
export const PLACEHOLDER_IMAGE = require('@/assets/images/BB24_Logo_2000x2000.webp');
export const PLACEHOLDER_IMAGE_WEB = 'https://cdn.baum-exchange.de/headless/BB24_Logo_2000x2000.webp';
export const IP_API_URL = 'https://api64.ipify.org?format=json';

export const FACEBOOK = {
    pixelID: '1257805262943832'
}

export const STRAPI = {
    host: "https://strapi.baum-bmwshop24.de",
    url: "https://strapi.baum-bmwshop24.de/graphql",
}

export const CODEIGNITER = {
    baseUrl: "https://api.core.baum-bmwshop24.de",
    url: "https://api.core.baum-bmwshop24.de/graphql",
}

export const GOOGLE = {
    API_TOKEN: 'AIzaSyAMm1Dh4PMvptPSq5NCbgy8_OVA8jHeSVk',
    MAPS_API: 'https://maps.googleapis.com/maps/api/geocode/json?address=',
};

export const BREAKPOINTS_EXTENDED = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};

export const BREAKPOINTS = {
    PHONE: BREAKPOINTS_EXTENDED.sm,
    TABLET: BREAKPOINTS_EXTENDED.md,
    DESKTOP: BREAKPOINTS_EXTENDED.lg,
};


export const x1S = 'fuw@';
export const x1E2 = '@2BZ8';
export const x1C = '@!ufFDxr3';
export const x1R = '@YhqTH.Q';
export const x1E = 'Z8z2BZ8rTxe';
export const x1T = '@8rTxe@!';